// extracted by mini-css-extract-plugin
export default {"cta":"nG-z","disabled":"oG-z"};